module.exports = __webpack_public_path__ + "img/iPhone-homescreen@2x.d308098e.png";